import { render, staticRenderFns } from "./create-testPaper.vue?vue&type=template&id=70d2366e&scoped=true&"
import script from "./create-testPaper.vue?vue&type=script&lang=ts&"
export * from "./create-testPaper.vue?vue&type=script&lang=ts&"
import style0 from "./create-testPaper.vue?vue&type=style&index=0&id=70d2366e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d2366e",
  null
  
)

export default component.exports